module.exports = __webpack_public_path__ + "static/export.b39cccf440948948c279212fe103716d.svg";